export default "__VITE_ASSET___6Ecvyaw__"